import { Outlet, ScrollRestoration } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";
import { useReveal } from "../../hooks/useReveal";

export default function Layout() {
  useReveal();
  return (
    <div className="relative bg-[#050505] text-white min-h-screen overflow-x-hidden">
      <Navbar />
      <Outlet />
      <Footer />
      <FloatingWhatsApp />
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,138,0,0.25)",
            color: "#fff",
          },
        }}
      />
      <ScrollRestoration />
    </div>
  );
}
